import React from "react";
import "./maximiseYourPensionModal.scss";
import { Icons } from "../../atoms/Icons";
const MaximiseYourPensionModal = (props) => {
  return (
    <div className="maximise-your-pension-modal">
      <div className="text-end">
        <Icons
          iconname="close-large"
          variant="icon-sixteen-px"
          clickHandler={props.handleCloseButton}
        />
      </div>
      <div className="heading mt-2 mb-4">{props.headTitle}</div>
      <div className="sub-text">
        <p>{props.description}</p>
        <p>{props.subDescription}</p>
        <p>{props.subDescription1}</p>
      </div>
    </div>
  );
};

export default MaximiseYourPensionModal;
